import React, { Fragment, Component } from 'react';
import { translate } from '../Services/translation';

class FacetedSearchGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: false,
            showLessItemCount : 25000
        };
        this.toggleShowMore = this.toggleShowMore.bind(this);
        this.expandFilters = this.expandFilters.bind(this);
    }

    componentDidMount() {
        const visible = this.refs.list.getBoundingClientRect().height !== 0;
        const tooMuchItem = this.props.group.options.length > this.state.showLessItemCount;
        visible && tooMuchItem && this.toggleShowMore();
    }

    toggleShowMore() {
        const topPos = this.refs.list.getBoundingClientRect().top;
        const lessBottomPos = this.refs.showLess.getBoundingClientRect().bottom;
        const moreBottomPos = this.refs.showMore.getBoundingClientRect().bottom;
        const setHeight = () => this.refs.list.style.height = `${ (this.state.collapsed ? lessBottomPos : moreBottomPos ) - topPos }px`;
        const toggleCollapse = () => {
            this.setState((prevState, props) => ({
                collapsed: !prevState.collapsed
            }),()=> {
                setHeight();
            });
        }
        if( !this.refs.list.style.height ) {
            setHeight();
            setTimeout(()=> {toggleCollapse()}, 0);
        }
        else {
            toggleCollapse();
        }
    }

    expandFilters(group) {
        // Redux didnt want to work at this moment. So we are just changing the dom for now.
        // Which is why ${group.expanded ? "expanded" : ""} works for the first filter.
        // TODO Use redux.
        group.expanded = !group.expanded;
        var domGroup = document.getElementById(group.id);
        if (group.expanded) {
            domGroup.classList.add("expanded");
        }
        else {
            domGroup.classList.remove("expanded");
        }
    }

    render() {
        const { group, searchFacetChange } = this.props;
        return (
            <Fragment>
                <ul id={group.id} className={`faceted-search__group ${group.expanded ? "expanded" : ""}`} ref="list">
                    <div className="faceted-search__group-header-div" onClick={() => this.expandFilters(group)}>
                        <h4 className="faceted-search__group-header" role="faceted-search-item-group">{ group.label }</h4>
                        <span className="subnav__arrow">
                            <img src="/ui/images/arrow-down.svg" alt="Open nav icon" />
                        </span>
                    </div>
                    {group.options && group.options.map((item, itemIndex, array) => (
                        <li key={`${item.label}-${itemIndex}`} className="faceted-search__item" role="faceted-search-item" ref={itemIndex===this.state.showLessItemCount-1 ? "showLess" : itemIndex===array.length-1 ? "showMore" : null}>
                            <FacetedFilterCheckbox item={item} group={group} searchFacetChange={searchFacetChange}/>
                        </li>
                    ))}
                </ul>
                {group.options.length > this.state.showLessItemCount &&
                    <span className="faceted-search__show-more" onClick={this.toggleShowMore}>
                        {`${ this.state.collapsed ? translate('filter.showmore') : translate('filter.showless')}`}
                    </span>
                }
            </Fragment>
        )
    }
}

const FacetedSearch = ({facetFilters, searchFacetChange, navigationTheme}) => navigationTheme !== 'category' && (

    <ul className="faceted-search">
        <div className="product-filter-header">
            <div className="filter-header-text">
                <p className="small-title filter-title">{translate('filter.title')}</p>
            </div>
            <button id="close-filter" className="close-filter-button"><img src="/ui/images/filter-close.svg" alt="Close filter icon"/></button>
        </div>
        {facetFilters && facetFilters.map((group, groupIndex, array) => (
            <FacetedSearchGroup key={`${group.label}-${groupIndex}`} group={group} searchFacetChange={searchFacetChange}/>
        ))}
    </ul>
)

const FacetedFilterCheckbox = ({item, group, searchFacetChange}) => (
    <label className="faceted-filter" >
        <input className="faceted-filter__input" type="checkbox" onChange={event => searchFacetChange(group, item)} checked={group.selectedOptions != null && group.selectedOptions.includes(item.id)} />
        <span className="faceted-filter__label">
            {item.label}
            {!isNaN(item.quantity) && (item.quantity != null) &&
                <span className="faceted-filter__quantity">&nbsp;({item.quantity})</span>
            }
        </span>
    </label>
)

export default FacetedSearch;
